// extracted by mini-css-extract-plugin
export var addToCartButton = "_qw-b";
export var arrowButtonContainer = "_qw-9";
export var arrowButtonIcon = "_qw-a";
export var carouselArrowButton = "_qw-6";
export var carouselElementContainer = "_qw-1";
export var left = "_qw-7";
export var productDisplayCarouselContainer = "_qw-0";
export var productTileContainer = "_qw-2";
export var productTileImage = "_qw-4";
export var productTileImageContainer = "_qw-3";
export var productTileTitle = "_qw-5";
export var right = "_qw-8";
export var sliderOverflow = "_qw-c";